var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefoxBrowser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ni63zsv3za"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1486 0v950H0V0h1486z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "altu8bfvkb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.347 0 .015.002a.04.04 0 0 1 .035.04c.053.213.13.42.231.614.053.109.11.216.171.32.118.2.24.399.366.594 2.428 3.838 5.402 5.6 7.155 9.973l-.003-.026a16.113 16.113 0 0 0-1.57-4.708c1.07.554 2.437 2.305 3.111 3.926a15.947 15.947 0 0 1 1.006 7.79c-.023.203-.044.4-.07.6-1.369 7.934-8.58 13.502-16.6 12.818C6.171 31.26.006 24.553 0 16.503v-.08a14.78 14.78 0 0 1 .252-2.138l.003-.034c.045-.324.096-.646.153-.968l.02-.103A13.098 13.098 0 0 1 2.51 8.481l.267-.366c.363-.484.758-.942 1.183-1.373.466-.477.973-.911 1.516-1.298.162-.11.336-.202.518-.275-.035.536-.079 3.105.536 3.885a11.59 11.59 0 0 1 3.74-2.886 7.19 7.19 0 0 0 .044 3.791c.139.094.272.195.4.303a7.758 7.758 0 0 1 4.268-1.645c.122-2.112 1.443-6.334 5.339-8.615l-.006.01.011-.006c.017-.007.027-.007.037-.004z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6wp61hwcpd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.747 0c1.07.553 2.437 2.304 3.111 3.926a15.947 15.947 0 0 1 1.006 7.79c-.023.202-.044.4-.07.6-1.369 7.934-8.58 13.501-16.6 12.818C6.171 24.45.006 17.744 0 9.694v-.08c.016-.72.1-1.436.25-2.14-.11.906-.328 1.471-.11 2.587 1.198 7.072 7.606 12.472 14.883 12.678 6.735.19 11.037-3.72 12.815-7.533a14.045 14.045 0 0 0 .482-10.468l-.003-.016v-.015A16.113 16.113 0 0 0 26.747 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "yprd63b8kg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.339 0-.006.009c-.6.286-4.157 5.918.663 10.74a8.443 8.443 0 0 1 1.44 1.878c-.03-.024-.062-.047-.096-.07a7.827 7.827 0 0 0-6.795-3.97c-.185 0-.364.016-.545.028C.122 6.503 1.443 2.281 5.339 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "hxcqapungi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.981 0a7.827 7.827 0 0 1 6.796 3.968 5.354 5.354 0 0 0-3.74-.908c5.578 2.788 4.08 12.394-3.649 12.031a6.897 6.897 0 0 1-2.018-.389 8.605 8.605 0 0 1-.455-.186 5.378 5.378 0 0 1-.262-.125C1.761 13.412.195 11.56 0 9.315L.005 9.3c.068-.22.911-2.652 5.121-2.652.477 0 1.84-1.33 1.865-1.716-.006-.126-2.705-1.2-3.757-2.237-.563-.554-.83-.822-1.066-1.022A7.758 7.758 0 0 1 6.436.028C6.617.015 6.797 0 6.981 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cvrnjsalol"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.733 0a7.19 7.19 0 0 0 .044 3.79c-.091-.062-.195-.132-.32-.212C2.507 2.96.767 2.89.19 2.885H0A11.486 11.486 0 0 1 3.733 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mm5b7o86qn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28.261 6.393.118.35a14.046 14.046 0 0 1-.606 10.1c-1.777 3.813-6.08 7.723-12.814 7.533C7.682 24.169 1.272 18.77.075 11.697c-.271-1.249.28-3.658.287-3.69a13.098 13.098 0 0 1 2.081-4.699l.268-.365c.365-.483.761-.94 1.188-1.37.466-.476.973-.91 1.516-1.298.162-.11.335-.202.517-.275-.035.537-.078 3.106.537 3.885h.026c.233-.004 2.35-.013 3.436.693.125.081.228.15.32.212.139.094.273.195.4.304.237.2.504.467 1.066 1.021 1.052 1.037 3.751 2.111 3.757 2.237a7.723 7.723 0 0 1-5.823-.229 5.85 5.85 0 0 0-5.701.23 3.983 3.983 0 0 0 3.673 2.31c-.287 2.535 1.054 5.492 4.298 7.043.076.039.15.076.226.112 1.078.734 6.404 2.532 11.97-2l.008-.02c2.857-2.354 4.684-5.834 4.134-9.426l.002.021z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7iitlelarp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.86 0 .014.002a.04.04 0 0 1 .035.04c.053.213.13.42.231.614.053.109.11.216.171.32.118.2.24.399.366.594 2.428 3.838 5.402 5.6 7.156 9.975.549 3.592-1.277 7.072-4.133 9.426.137-.327 1.98-4.908-1.537-8.15a3.033 3.033 0 0 0-.232-.19 8.443 8.443 0 0 0-1.44-1.88C-2.332 5.928 1.225.295 1.825.011l.011-.006c.017-.007.027-.007.037-.004z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9ygo47g2ar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.384.045a5.354 5.354 0 0 1 3.836.979c.08.06.158.123.232.19 3.518 3.24 1.676 7.823 1.537 8.148l-.009.02c-5.567 4.534-10.891 2.736-11.97 2L0 11.376a8.175 8.175 0 0 0 .717.311c.65.23 1.33.36 2.018.39 7.73.362 9.227-9.243 3.65-12.032z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cv1e705jht"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 .862a5.85 5.85 0 0 1 5.702-.23 7.723 7.723 0 0 0 5.823.23c-.025.385-1.389 1.716-1.865 1.716-4.41 0-5.126 2.668-5.126 2.668.195 2.246 1.759 4.097 3.653 5.075-.075-.034-.143-.07-.215-.106-3.245-1.55-4.585-4.507-4.298-7.042A3.983 3.983 0 0 1 0 .862z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3n9jec3z6v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.198 22.98.13.065.132.06c.151.068.303.13.455.187.65.23 1.33.361 2.018.39 7.73.362 9.227-9.243 3.65-12.032a5.354 5.354 0 0 1 3.739.908 7.827 7.827 0 0 0-6.796-3.969c-.185 0-.364.016-.545.028.122-2.112 1.443-6.334 5.339-8.615l-.006.01.011-.006c.017-.007.027-.007.037-.004a.04.04 0 0 1 .035.04c.053.213.13.42.231.614.053.109.11.216.171.32.118.2.24.399.366.594 2.428 3.838 5.402 5.6 7.155 9.973l-.003-.026a16.113 16.113 0 0 0-1.57-4.708c1.07.554 2.437 2.305 3.111 3.926a15.947 15.947 0 0 1 1.006 7.79c-.023.203-.044.4-.07.6-1.369 7.934-8.58 13.502-16.6 12.818C6.171 31.26.006 24.553 0 16.503v-.08c.033-.724.11-1.446.229-2.162l.012-.08a31.5 31.5 0 0 1 .167-.898l.02-.103A13.098 13.098 0 0 1 2.51 8.481l.267-.366c.363-.484.758-.942 1.183-1.373.466-.477.973-.911 1.516-1.298.162-.11.336-.202.518-.275-.035.536-.079 3.105.536 3.885a11.59 11.59 0 0 1 3.74-2.886 7.19 7.19 0 0 0 .044 3.791c.139.094.272.195.4.303.236.2.503.468 1.066 1.022 1.052 1.036 3.751 2.11 3.757 2.236-.024.387-1.388 1.717-1.865 1.717-4.41 0-5.126 2.668-5.126 2.668.195 2.246 1.759 4.097 3.653 5.076z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "5ljrzjo22e",
    cx: 30.786,
    cy: -3.258,
    r: 23.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB92C",
    offset: "12.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA700",
    offset: "18.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600",
    offset: "24.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "28.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4227",
    offset: "40.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0048",
    offset: "46.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF006A",
    offset: "71%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0078",
    offset: "78.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA0081",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "3slma5v8gf",
    cx: 24.501,
    cy: 9.96,
    r: 7.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4000C",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(193, 0, 29, 0.74)",
    offset: "35.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(238, 0, 53, 0.343)",
    offset: "43.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 0, 67, 0.094)",
    offset: "49.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 0, 72, 0)",
    offset: "53%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d751nxr7th",
    cx: 6.81,
    cy: -3.788,
    r: 9.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF300",
    offset: "13.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA00",
    offset: "25.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600",
    offset: "50.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "52.6%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "nxd3dwv8lj",
    cx: 8.114,
    cy: 16.625,
    r: 9.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090ED",
    offset: "35.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537AF8",
    offset: "47.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95F",
    offset: "66.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D126EE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sfqm1x0cek",
    cx: 9.658,
    cy: 5.135,
    r: 6.277,
    gradientTransform: "rotate(-13.592 9.658 5.135)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(153, 85, 255, 0)",
    offset: "20.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(149, 75, 251, 0.064)",
    offset: "27.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(130, 1, 174, 0.45)",
    offset: "74.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(120, 0, 144, 0.6)",
    offset: "97.5%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "8fp194ad3m",
    cx: 7.86,
    cy: -3.94,
    r: 8.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD900",
    offset: "12.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC500",
    offset: "29.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA400",
    offset: "50.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7411",
    offset: "73.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF641D",
    offset: "79.2%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "9lgry9gyeo",
    cx: 28.371,
    cy: -9.969,
    r: 37.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF300",
    offset: "11.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "45.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF421A",
    offset: "62.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF003D",
    offset: "71.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80089",
    offset: "90.4%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s1glasrvfq",
    cx: 0.628,
    cy: -2.169,
    r: 25.523,
    gradientTransform: "rotate(83.976 .628 -2.169)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF300",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    offset: "6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC500",
    offset: "16.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "30.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8200",
    offset: "35.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5800",
    offset: "45.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF003D",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80089",
    offset: "73.7%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "tv87yiolks",
    cx: 5.977,
    cy: -5.275,
    r: 22.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF300",
    offset: "13.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF421A",
    offset: "59.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF003D",
    offset: "65.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80089",
    offset: "90.4%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v6qh75zg6u",
    cx: 20.943,
    cy: -4.602,
    r: 17.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF300",
    offset: "9.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF00",
    offset: "23.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA0",
    offset: "50.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "62.6%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ydfom3dabc",
    x1: 26.569,
    y1: 6.15,
    x2: 9.655,
    y2: 22.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF300",
    offset: "4.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE600",
    offset: "11.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC500",
    offset: "22.5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    offset: "36.8%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8200",
    offset: "40.1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5800",
    offset: "46.2%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF003D",
    offset: "53.4%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F80089",
    offset: "70.5%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2ddxkue8tw",
    x1: 23.837,
    y1: 8.483,
    x2: 14.352,
    y2: 17.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 243, 0, 0.8)",
    offset: "16.7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 243, 0, 0.634)",
    offset: "26.6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 243, 0, 0.217)",
    offset: "48.9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgba(255, 243, 0, 0)",
    offset: "60%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ni63zsv3za)",
    transform: "translate(-433 -285)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#altu8bfvkb)",
    transform: "translate(433.51 285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#ydfom3dabc)",
    d: "M0 0h30.98v32H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6wp61hwcpd)",
    transform: "translate(433.51 291.81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#5ljrzjo22e)",
    d: "M0 0h30.98v25.19H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6wp61hwcpd)",
    transform: "translate(433.51 291.81)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#3slma5v8gf)",
    d: "M0 0h30.98v25.19H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#yprd63b8kg)",
    transform: "translate(448.491 285.002)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#d751nxr7th)",
    d: "M0 0h7.437v12.627H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hxcqapungi)",
    transform: "translate(442.055 293.59)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#nxd3dwv8lj)",
    d: "M0 0h13.777v15.101H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hxcqapungi)",
    transform: "translate(442.055 293.59)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#sfqm1x0cek)",
    d: "M0 0h13.777v15.101H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cvrnjsalol)",
    transform: "translate(440.044 291.168)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#8fp194ad3m)",
    d: "M0 0h3.777v3.79H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mm5b7o86qn)",
    transform: "translate(433.577 290.173)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#9lgry9gyeo)",
    d: "M0 0h29.042v24.382H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7iitlelarp)",
    transform: "translate(451.998 285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#s1glasrvfq)",
    d: "M0 0h9.93v20.97H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9ygo47g2ar)",
    transform: "translate(445.707 296.605)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tv87yiolks)",
    d: "M0 0h12.594v12.36H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cv1e705jht)",
    transform: "translate(437.521 297.66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#v6qh75zg6u)",
    d: "M0 0h11.525v10.32H0V0z"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3n9jec3z6v)",
    transform: "translate(433.51 285)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#2ddxkue8tw)",
    d: "M0 0h30.98v32H0V0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefoxBrowser);
export default __webpack_public_path__ + "static/media/firefox-browser.9a40d446ab219d15e95708c47acf313d.svg";
export { ForwardRef as ReactComponent };